import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RichText } from '../../atoms/RichText/RichText.js';
import { cn } from '../../lib/cn.js';
import { useTranslate } from '../../lib/i18n.js';
/**
 * An ordering answer, written out.
 *
 * Text rather than option ids, because every caller has already resolved them:
 * the student's completion review is handed text by the server, and the
 * tutor's review and the authored view both hold the options and can look them
 * up. Nothing here decides what may be shown — a list this is not given is a
 * list it does not draw.
 *
 * Numbered, and the numbers are the point. "Water condenses, Water evaporates"
 * read as a sentence is a comma-separated list; read as `1.` and `2.` it is an
 * answer to a question about order.
 */
export function AssociationResult({ yourOrder, correctOrder, yourLabel, correctLabel, className, }) {
    const t = useTranslate();
    const showYours = yourOrder !== undefined;
    const showCorrect = correctOrder !== undefined && correctOrder.length > 0;
    if (!showYours && !showCorrect)
        return null;
    return (_jsxs("div", { className: cn('grid gap-4 sm:grid-cols-2', className), children: [showYours ? (_jsx(OrderColumn, { label: yourLabel ?? t('common.yourAnswer'), order: yourOrder, tone: "neutral" })) : null, showCorrect ? (_jsx(OrderColumn, { label: correctLabel ?? t('common.correctAnswer'), order: correctOrder, tone: "accent" })) : null] }));
}
function OrderColumn({ label, order, tone, }) {
    const t = useTranslate();
    return (_jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("p", { className: cn('text-body-sm font-semibold', tone === 'accent' ? 'text-accent-text' : 'text-text-strong'), children: label }), order.length === 0 ? (_jsx("p", { className: "text-body text-text-secondary", children: t('ui.ordering.leftBlank') })) : (_jsx("ol", { className: "flex flex-col gap-1", children: order.map((text, index) => (_jsxs("li", { className: cn('flex items-baseline gap-2 rounded-sm border px-3 py-1.5 text-body', tone === 'accent'
                        ? 'border-accent-border bg-accent-light text-text'
                        : 'border-border bg-surface text-text'), children: [_jsxs("span", { className: "font-semibold tabular-nums text-text-secondary", children: [index + 1, "."] }), _jsx("span", { className: "text-pretty", children: _jsx(RichText, { inline: true, children: text }) })] }, `${index}-${text}`))) }))] }));
}
//# sourceMappingURL=AssociationResult.js.map